<template>
  <div
    class="default-user-avatar"
    :class="{
            ['avatar-' + color]: bgColor == '',
            [`${bgColor}`]: bgColor != '',
            [`md:mx-auto`]: isLoggedOut
        }"
    :style="{
            width: size + 'px',
            height: size + 'px',
            'font-size': fontSize,
        }"
  >
    <span>{{initials}}</span>
  </div>
</template>

<script>
export default {
  props: {
    firstName: { type: String, required: true },
    lastName: { type: String, required: true },
    size: { type: String|Number, default: 16 },
    isLoggedOut: { type: Boolean, default: true },
    bgColor: { type: String, default: "", required: false }
  },

  computed: {
    initials() {
      return (this.firstName.charAt(0) + this.lastName.charAt(0)).toUpperCase();
    },

    color() {
      const letterNum = this.firstName.toLowerCase().charCodeAt(0);

      if (letterNum < 102) {
        return "yellow";
      } else if (letterNum < 107) {
        return "light-blue";
      } else if (letterNum < 111) {
        return "red";
      } else if (letterNum < 116) {
        return "green";
      } else if (letterNum < 120) {
        return "orange";
      } else {
        return "purple";
      }
    },

    fontSize() {
      return Math.floor((this.size * 10) / 26) + "px";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "styles/_avatars.scss";

.default-user-avatar {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 400;
  border-radius: 50%;
  font-size: 10px;
  flex-shrink: 0;
}
</style>